module.exports = __webpack_public_path__ + "img/1f5d3.a92891f.svg";